// extracted by mini-css-extract-plugin
module.exports = {"company":"CompanyFormFields_company__3vLq2","addressRow":"CompanyFormFields_addressRow__2h99r","addressCol":"CompanyFormFields_addressCol__2XjLr"};